/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Password_PlaceholderInputs */

const en_common_sign_password_placeholder = /** @type {(inputs: Common_Sign_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your password`)
};

/**
* | output |
* | --- |
* | "Enter your password" |
*
* @param {Common_Sign_Password_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_sign_password_placeholder = /** @type {((inputs?: Common_Sign_Password_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Password_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_sign_password_placeholder(inputs)
});
export { common_sign_password_placeholder as "common.sign.password_placeholder" }